/* eslint-disable no-param-reassign */

export const jsonHasValue = (obj) => obj && Object.keys(obj)?.length > 0;

export const memorizeMultipleArgs = (fn) => {
  let lastArg;
  let lastResult;
  return (...arg) => {
    if (arg[0] !== lastArg) {
      // eslint-disable-next-line prefer-destructuring
      lastArg = arg[0];
      lastResult = fn(...arg);
    }
    return lastResult;
  };
};

export const removeKeysFromJSON = (obj, keys) => {
  console.log('removeKeysFromJSON');
  Object.keys(obj).forEach(
    (key) => {
      keys.forEach((k) => {
        if (key === k) delete obj[k];
      });
    }
  );
  return obj;
};

export const replacePathParams = (path, params, prefix = ':') => {
  let newPath = path;
  Object.entries(params).forEach(([key, value]) => {
    newPath = newPath.replace(prefix + key, value);
  });
  return newPath;
};
